<template>
	<div>
		<v-card class="ma-4">
			<v-card-title class="mb-3">
				<h2>{{item.name}} ({{item.shortName}})</h2>
			</v-card-title>
		</v-card>
		<router-view></router-view>
	</div>
</template>

<script>
import {PublicContest} from "@/api/generated/PublicContest";

export default {
  name: "ContestNameView",

  methods: {
    updateNames (name, shortName) {
      this.item.name = name;
      this.item.shortName = shortName;
    }
  },

  created() {
    PublicContest.getPanelInfo(this, this.$route.params.id,
        successResponse => {
          this.item.name = successResponse.name;
          this.item.shortName = successResponse.shortName;
        });
  },

  data() {
    return {
      item: {
        name: "",
        shortName: "",
      },
    };
  },
};
</script>

<style scoped>

.contest-panel-view-title {
  margin-left: 20px;
}

</style>